import { render, staticRenderFns } from "./Comentario.vue?vue&type=template&id=6c738aad"
import script from "./Comentario.vue?vue&type=script&lang=js"
export * from "./Comentario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports